import { render, staticRenderFns } from "./TestEmailPreset.vue?vue&type=template&id=37110828&scoped=true&"
import script from "./TestEmailPreset.vue?vue&type=script&lang=js&"
export * from "./TestEmailPreset.vue?vue&type=script&lang=js&"
import style0 from "./TestEmailPreset.vue?vue&type=style&index=0&id=37110828&lang=scss&scoped=true&"
import style1 from "./TestEmailPreset.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37110828",
  null
  
)

export default component.exports